// Theme configuration for Admin Panel V2
export const lightTheme = {
  mode: 'light',
  colors: {
    primary: '#19B888', // Fit app green
    primaryDark: '#173430', // Fit app neutralDark
    primaryLight: '#19B88833', // Fit app green20
    secondary: '#617D79', // Fit app grey
    background: '#ffffff',
    surface: '#F6F7F7', // Fit app softGrey
    surfaceElevated: '#ffffff',
    text: '#212529', // Fit app text
    textSecondary: '#617D79', // Fit app grey
    border: '#e5e7eb',
    borderLight: '#F6F7F7', // Fit app softGrey
    error: '#FF395D', // Fit app red
    warning: '#FF8C39', // Fit app orange
    success: '#19B888', // Fit app green
    info: '#39ACFF', // Fit app blue
    hover: '#F6F7F7', // Fit app softGrey
    shadow: 'rgba(0, 0, 0, 0.1)',
  },
  fonts: {
    primary: '"Nunito", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"Courier New", Courier, monospace',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
};

export const darkTheme = {
  mode: 'dark',
  colors: {
    primary: '#19B888', // Fit app green (hacker green)
    primaryDark: '#173430', // Fit app neutralDark
    primaryLight: '#19B88833', // Fit app green20
    secondary: '#617D79', // Fit app grey
    background: '#000000',
    surface: '#0a0a0a',
    surfaceElevated: '#111111',
    text: '#19B888', // Fit app green (hacker green text)
    textSecondary: '#19B888',
    border: '#1a1a1a',
    borderLight: '#0f0f0f',
    error: '#FF395D', // Fit app red
    warning: '#FF8C39', // Fit app orange
    success: '#19B888', // Fit app green
    info: '#39ACFF', // Fit app blue
    hover: '#1a1a1a',
    shadow: 'rgba(25, 184, 136, 0.1)', // Fit app green with opacity
    // Hacker style effects
    glow: 'rgba(25, 184, 136, 0.3)', // Fit app green glow
    scanline: 'rgba(25, 184, 136, 0.05)', // Fit app green scanline
  },
  fonts: {
    primary: '"Courier New", Courier, monospace', // Monospace for hacker feel
    mono: '"Courier New", Courier, monospace',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 255, 0, 0.1)',
    md: '0 4px 6px -1px rgba(0, 255, 0, 0.15)',
    lg: '0 10px 15px -3px rgba(0, 255, 0, 0.2)',
    xl: '0 20px 25px -5px rgba(0, 255, 0, 0.25)',
  },
};

export const getTheme = (isDark) => (isDark ? darkTheme : lightTheme);

